import { createContext, MutableRefObject } from 'react';

export const ScrollContext = createContext<MutableRefObject<HTMLDivElement>>(null);
